import { Card, Divider, Space } from "antd";
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Countdown from "antd/lib/statistic/Countdown";
import { useStopwatch } from "react-timer-hook";
import config from "../../../config";
import SideMenu from "../../dashboard/sideMenu";
import { useSelector } from "react-redux";

const itemTypes = {
  starter: "Starters",
  dessert: "Desserts",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      margin: "0",
    },
    "& h4": {
      margin: "0",
    },
  },
  tabs: {
    "& .ant-tabs-nav": {
      background: "#FDFBE8",
      "& .ant-tabs-tab-active": {
        background: "#fff",
      },
    },
    "& .ant-tabs-tab": {
      margin: "0",
    },
  },
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
  },
  contentListStyle: {
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "body::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
  },
  customCol6: {
    display: "flex",
    justifyContent: "center",
  },
  Countdown: {
    "& .ant-statistic-content-value": {
      fontSize: "1rem !important",
    },
    "& .ant-statistic-title": {
      marginBottom: "0 !important",
    },
  },
}));

const types = {
  dine_in: "Dine In",
  online: "Online Order",
  parcel: "parcel",
  delivery: "Delivery",
};

const KitchenCard = ({ item, id, setOrders, kotsub = false }) => {
  const classes = useStyles();
  const [status, setStatus] = React.useState(item.status);
  console.log("status", status);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const { seconds, minutes, hours, days, isRunning, start, pause, reset } =
    useStopwatch({ autoStart: false });

  const updateKotStatus = async (status, billId) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/kot/manageKot`, {
        method: "POST",
        body: JSON.stringify({
          status: status,
          billId: billId,
          action: "changeKotStatus",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        return data;
      })
      .catch((err) => {
        console.log("err".err);
      });
  };

  const handleClick = () => {
    if (status === "created") {
      start();
      setStatus("progress");
      updateKotStatus("progress", item.billId);
      setOrders((prev) => {
        return prev.map((order) => {
          if (order.billId === item.billId) {
            console.log("setOrders", order);
            order.status = "progress";
          }
          return order;
        });
      });
    }
    if (status === "progress") {
      pause();
      setStatus("done");
      updateKotStatus("done", item.billId);
      setOrders((prev) => {
        return prev.map((order) => {
          if (order.billId === item.billId) {
            order.status = "done";
          }
          return order;
        });
      });
    }
  };

  useEffect(() => {
    if (status === "progress") {
      start();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Card
      bodyStyle={{
        padding: "0",
        background: "#fff",
        borderRadius: "8px",
      }}
      className={classes.root}
      style={{
        width: "274px",
        borderRadius: "8px",
        boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",
      }}
    >
      <div
        style={{
          background: "#F3F3F3",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "16px",
            position: "relative",
            borderBottom: "1px solid #D4D4D4",
          }}
        >
          <span
            style={{
              padding: "4px 14px",
              background: "#EF4667",
              borderRadius: "4px",
              color: "#fff",
              position: "absolute",
              top: 12,
              left: 14,
              fontWeight: 700,
            }}
          >
            {id < 10 ? `0${id + 1}` : id}
          </span>
          <div
            style={{
              fontWeight: "bold",
            }}
          >
            <div style={{ fontSize: "16px" }}>
              <span>{hours < 10 ? `0${hours}` : hours}</span>:
              <span>{minutes < 10 ? `0${minutes}` : minutes}</span>:
              <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
            </div>
          </div>
        </div>
        <Space
          direction="horizontal"
          style={{
            justifyContent: "space-between",
            padding: 16,
            width: "100%",
          }}
        >
          <div>
            <h4>{types[item.orderType]}</h4>
            {!kotsub && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#A1A1A1",
                }}
              >
                {item.billingDate}
              </p>
            )}
            {item.waiterName && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#A1A1A1",
                }}
              >
                Waiter:
                <span
                  style={{
                    color: "initial",
                  }}
                >
                  {" "}
                  {item.waiterName}
                </span>
              </div>
            )}
          </div>
          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                color: "#A1A1A1",
              }}
            >
              #{item.orderId}
            </p>
            <div
              style={{
                fontSize: "12px",
                marginTop: 30,
              }}
            >
              No. of Items:<span>{item.items.length}</span>
            </div>
          </div>
        </Space>
      </div>
      <div
        style={{
          padding: "18px 30px 60px",
          height: "262px",
          overflowY: "auto",
        }}
        className={classes.contentListStyle}
      >
        {item.items.map((order, index, arr) => {
          return (
            <React.Fragment key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <p>{order.productName}</p>
                <p>{order.count}</p>
              </div>
              {arr?.length - 1 !== index && (
                <Divider className={classes.dividerStyle} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {status !== "done" && (
        <button
          style={
            status === "progress"
              ? {
                  padding: "14px 0",
                  display: "block",
                  textAlign: "center",
                  background: "#25A75D",
                  width: "100%",
                  border: 0,
                  color: "#fff",
                  borderRadius: "0 0 8px 8px",
                  position: "absolute",
                  bottom: "-4px",
                  left: 0,
                  zIndex: 1,
                }
              : {
                  padding: "14px 0",
                  display: "block",
                  textAlign: "center",
                  background: "#EF4869",
                  width: "100%",
                  border: 0,
                  color: "#fff",
                  borderRadius: "0 0 8px 8px",
                  position: "absolute",
                  bottom: "-4px",
                  left: 0,
                  zIndex: 1,
                }
          }
          onClick={handleClick}
        >
          {status === "created" && (
            <span
              style={{
                fontWeight: "500",
              }}
            >
              Start Cooking
            </span>
          )}
          {status === "progress" && (
            <span
              style={{
                fontWeight: "500",
              }}
            >
              Mark as done
            </span>
          )}
        </button>
      )}
    </Card>
  );
};

export default React.memo(KitchenCard);
